var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiperDnaActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -42)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.587,
    cy: 15.587,
    r: 15.587,
    transform: "translate(1.413 1.413)",
    fill: "#33b0ce"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.495 -32.353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.541,94.03,44.9,94a9.232,9.232,0,0,1-2.173,1.1,9.237,9.237,0,0,1-2.185-1.072m2.2,2.335A9.141,9.141,0,0,1,44.849,97.4l-4.21.026a9.172,9.172,0,0,1,2.1-1.057M39.527,98.61l6.446-.04a.888.888,0,0,1,.1.37v.045a.856.856,0,0,1-.1.371l-6.446.04a.856.856,0,0,1-.1-.37v-.045a.864.864,0,0,1,.1-.372m1.13,1.959,4.209-.026a9.1,9.1,0,0,1-2.1,1.057,9.14,9.14,0,0,1-2.114-1.031m2.122,2.293a9.458,9.458,0,0,1,2.067,1l-4.126.025a9.471,9.471,0,0,1,2.059-1.026m4.368-10.821a.6.6,0,0,0-.747-.384.582.582,0,0,0-.379.732v0a.723.723,0,0,1-.061.425l-6.494.04a.719.719,0,0,1-.067-.421.59.59,0,0,0-1.129-.342c-.03.1-.3,2.1,2.924,3.649-2.426,1.2-2.968,2.627-2.947,3.267-.013.64.546,2.063,2.987,3.23a6.146,6.146,0,0,0-2.284,1.775.571.571,0,0,0-.227.344,2.375,2.375,0,0,0-.368,1.565.6.6,0,0,0,.571.412.56.56,0,0,0,.176-.029.582.582,0,0,0,.381-.729l0-.007a.752.752,0,0,1,.086-.5l6.443-.04a.768.768,0,0,1,.093.494.589.589,0,0,0,.389.727.58.58,0,0,0,.181.027.59.59,0,0,0,.559-.413,2.383,2.383,0,0,0-.387-1.561.581.581,0,0,0-.229-.34,6.137,6.137,0,0,0-2.305-1.748c2.424-1.2,2.966-2.626,2.945-3.266.013-.64-.547-2.063-2.988-3.23,3.2-1.593,2.911-3.591,2.88-3.685",
    transform: "translate(-38.247 -91.628)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperDnaActiveIcon);
export default __webpack_public_path__ + "static/media/swiper_dna_active_icon.bea72b4f.svg";
export { ForwardRef as ReactComponent };